export default "__VITE_ASSET__Bjhpa$p___"